/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Tab_Alert_ThresholdInputs */



/**
* | output |
* | --- |
* | "Alert threshold" |
*
* @param {Usage_Tab_Alert_ThresholdInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_alert_threshold = /** @type {((inputs?: Usage_Tab_Alert_ThresholdInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Alert_ThresholdInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Benachrichtigungsschwelle")
	return /** @type {LocalizedString} */ ("Alert threshold")
});